import { IPublishMenuRequestBody, IPublishMenuResponseBody } from './types';
import { fetch } from '../fetchWrapper/fetch';
import { API_URL, Status } from '../constants';

const defaultErrorMessage = 'Something went wrong whilst publishing the menu';

export const publishMenu = async (
  menuId: string,
  payload: IPublishMenuRequestBody,
): Promise<IPublishMenuResponseBody> => {
  const res = await fetch(`${API_URL}/publish/${menuId}`, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      'content-type': 'application/json',
    },
  });

  const json = await res.json();

  if (res.status === Status.BAD_REQUEST) {
    throw new Error(json.message);
  }

  if (!res.ok) {
    let msg = defaultErrorMessage;
    if (Array.isArray(json?.errors) && typeof json.errors.at(0)?.message === 'string') {
      msg = json.errors.at(0)?.message;
    }

    throw new Error(msg);
  }
  return json;
};
